export enum RjcRadarChartSection {
    Process = 'process',
    Outcomes = 'outcomes',
    Lenience = 'lenience',
    Context = 'context',
}
